export const SET_FILTERS = 'SET_FILTERS'
export const SET_FILTERS_ACTIVE = 'SET_FILTERS_ACTIVE'
export const SET_FILTERS_PRESELECTED = 'SET_FILTERS_PRESELECTED'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_PARAMS = 'SET_PARAMS'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_UI = 'SET_UI'
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_QUERY_STEP = 'SET_QUERY_STEP'
export const SET_QUERY_STRING = 'SET_QUERY_STRING'
export const SET_FORMKEY = 'SET_FORMKEY'
export const SET_PATHNAME = 'SET_PATHNAME'
export const SET_NO_PRODUCTS_BLOCK = 'SET_NO_PRODUCTS_BLOCK'
export const SET_CATEGORY_FAQ = 'SET_CATEGORY_FAQ'
export const SET_CATEGORY_DESCR = 'SET_CATEGORY_DESCR'
export const SET_REDIRECT_TO_PAGE = 'SET_REDIRECT_TO_PAGE'
